<div class="container">
  <div class="bill-title">
    {{ bill.billTitle }} {{ currentDate | date : 'longDate' }}
  </div>
  <div class="bill-header">
    {{ bill.balanceTitle }}
  </div>
  <div class="bill-amount">
    <sup class="sup-text">&#36;</sup>{{ bill.billAmount
    }}<sup class="sup-text">.{{ bill.decimalBillAmount }}</sup>
  </div>
  <div class="bill-taxes">{{ bill.taxAmount }}</div>
  <div class="bill-date-title">
    {{ bill.billDateTitle }}
  </div>
  <div class="bill-date-title">
    {{ bill.dueDateTitle }}
  </div>
  <div class="bill-date">
    {{ bill.billDate | date : 'longDate' }}
  </div>
  <div class="due-date">
    {{ bill.dueDate | date : 'longDate' }}
  </div>
</div>
